interface BeforeInstallPromptEvent extends Event {
    prompt(): Promise<void>;
    userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferredPrompt: BeforeInstallPromptEvent | null = null;

export function setDeferredPrompt(prompt: BeforeInstallPromptEvent | null): void {
    deferredPrompt = prompt;
}

export function getDeferredPrompt(): BeforeInstallPromptEvent | null {
    return deferredPrompt;
}

export function clearDeferredPrompt(): void {
    deferredPrompt = null;
}
